import { useState } from 'react'
import { Box, Button } from '@chakra-ui/react'
import { LuTrash2 } from 'react-icons/lu'
import { showSuccess } from '@/lib/alert'
import { useDeleteEvent } from '@/hooks/events/useDeleteEvent'
import ConfirmActionDialog from '@/components/ConfirmActionDialog'

type Props = {
  agendaId: string
  eventId: string
  onSuccess?: () => void
}

const DeleteEventButton = ({ agendaId, eventId, onSuccess }: Props) => {
  const [open, setOpen] = useState(false)
  const { mutate: deleteEvent, isPending } = useDeleteEvent(agendaId, eventId)

  const handleConfirm = () => {
    deleteEvent(undefined, {
      onSuccess: () => {
        showSuccess('Evento removido com sucesso!')
        setOpen(false)
        onSuccess?.()
      },
    })
  }

  return (
    <>
      <Button colorPalette="red" variant="outline" onClick={() => setOpen(true)}>
        <LuTrash2 />
        <Box display={{ base: 'none', md: 'inline' }}>Remover</Box>
      </Button>

      {open && (
        <ConfirmActionDialog
          open={open}
          onOpenChange={setOpen}
          title="Remover evento"
          body={<>Tem certeza que deseja remover este evento? Esta ação não poderá ser desfeita.</>}
          onConfirm={handleConfirm}
          confirmLabel="Remover"
          confirmColorPalette="red"
          isPending={isPending}
        />
      )}
    </>
  )
}

export default DeleteEventButton
